import Home from "./../components/Home";
import Cards from "../components/Cards";
// import Sponsors from "../components/Sponsors";
import SATHome from "../components/SATHomePage";

const HomeInterface = () => {
  return (
    <>
      <Home />
      <SATHome />
      <Cards />
      {/* <Sponsors /> */}
    </>
  );
};
export default HomeInterface;
